/* Colour switcher — navigates to a linked sibling colour PRODUCT (a real
   separate Shopify product, not a variant of this one). If the customer
   has a size selected here and the exact same size (matched by variant
   title — reliable only because these are single-option, Size-only
   products) exists and is available on the sibling, carries it over via
   ?variant=; otherwise links to the plain product URL. Never guesses an
   unavailable size, never invents a size mapping. */
(function () {
  'use strict';

  document.addEventListener('click', function (evt) {
    var link = evt.target.closest('[data-mbg-colour-alt]');
    if (!link) {
      return;
    }

    var variantsAttr = link.getAttribute('data-variants');
    if (!variantsAttr) {
      return; // Plain href navigation, nothing to enhance.
    }

    var currentSelect = document.querySelector('.single-option-selector');
    var currentSize = currentSelect ? currentSelect.value : null;
    if (!currentSize) {
      return;
    }

    var siblingVariants;
    try {
      siblingVariants = JSON.parse(variantsAttr);
    } catch (e) {
      return;
    }

    var match = siblingVariants.filter(function (v) {
      return v.title === currentSize && v.available;
    })[0];

    if (match) {
      evt.preventDefault();
      var baseUrl = link.getAttribute('href').split('?')[0];
      window.location.href = baseUrl + '?variant=' + match.id;
    }
    // No match: let the plain href navigate to the sibling's default variant.
  });
})();
